import Swal from "sweetalert2";

export async function confirmLookupEdit(itemLabel = "") {
  const label = itemLabel ? `"${itemLabel}"` : "este item";

  const { isConfirmed } = await Swal.fire({
    title: "Atenção",
    icon: "warning",
    text: `Todos os contratos vinculados a ${label} serão atualizados. Deseja continuar?`,
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    allowOutsideClick: false,
  });

  return isConfirmed;
}
